<script>
import colors from 'vuetify/lib/util/colors'
import { Line } from 'vue-chartjs'

import { toHex } from '@/utils/format'

export default {
	extends: Line,
	props: {
		borderColors: {
			type: Array,
			default: () => [],
		},
		borderWidth: {
			type: Number,
			default: 1,
		},
		colors: {
			type: Array,
			default: () => [
				'purple',
				'blue',
				'orange',
				'green',
			],
		},
		fill: {
			type: Boolean,
			default: false,
		},
		fillOpacity: {
			type: [String, Number],
			default: 100,
		},
		headings: {
			type: Array,
			default: () => [
				'Dataset 1',
				'Dataset 2',
				'Dataset 3',
				'Dataset 4',
				'Dataset 5',
				'Dataset 6',
				'Dataset 7',
				'Dataset 8',
			],
		},
		labels: {
			type: Array,
			default: () => [],
		},
		value: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		hexFillOpacity() {
			return toHex((this.fillOpacity / 100) * 255)
		},
		hexBorderColors() {
			return this.colors.map((fillColor, i) => {
				const color = this.borderColors[i] || fillColor
				if (/^#/.test(color)) { return color }
				if (colors[color]) { return colors[color].base }
				console.warn(`Unrecognized color: ${color}`)
				return color
			})
		},
		hexColors() {
			return this.colors.map((color) => {
				if (/^#/.test(color)) { return `${color}${this.hexFillOpacity}` }
				if (colors[color]) { return `${colors[color].base}${this.hexFillOpacity}` }
				console.warn(`Unrecognized color: ${color}`)
				return color
			})
		},
	},
	data() {
		return {
			chartData: {
				labels: this.labels,
				datasets: this.getDataset(),
			},
			options: {
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true,
						},
						gridLines: {
							display: false,
						},
					}],
					xAxes: [{
						gridLines: {
							display: false,
						},
					}],
				},
				legend: {
					display: true,
				},
				responsive: true,
				maintainAspectRatio: false,
			},
		}
	},
	watch: {
		labels() {
			this.chartData.labels = this.labels
			this.updateChart()
		},
		value() {
			this.chartData.datasets = this.getDataset()
			this.updateChart()
		},
		headings() {
			this.chartData.datasets = this.getDataset()
			this.updateChart()
		},
		fill() {
			this.chartData.datasets = this.getDataset()
			this.updateChart()
		},
		colors() {
			this.chartData.datasets = this.getDataset()
			this.updateChart()
		},
		borderColors() {
			this.chartData.datasets = this.getDataset()
			this.updateChart()
		},
		borderWidth() {
			this.chartData.datasets = this.getDataset()
			this.updateChart()
		},
		fillOpacity() {
			this.chartData.datasets = this.getDataset()
			this.updateChart()
		},
	},
	methods: {
		updateChart() {
			if (this.$data._chart) {
				this.$data._chart.update()
			}
		},
		getDataset() {
			const hexBorderColors = this.colors.map((fillColor, i) => {
				const color = this.borderColors[i] || fillColor
				if (/^#/.test(color)) { return color }
				if (colors[color]) { return colors[color].base }
				console.warn(`Unrecognized color: ${color}`)
				return color
			})
			const hexColors = this.colors.map((color) => {
				if (/^#/.test(color)) { return `${color}${this.hexFillOpacity}` }
				if (colors[color]) { return `${colors[color].base}${this.hexFillOpacity}` }
				console.warn(`Unrecognized color: ${color}`)
				return color
			})

			return this.value.map((value, i) => ({
				...(this.headings[i] ? { label: this.headings[i] } : {}),
				data: value,
				fill: this.fill,
				borderColor: hexBorderColors[i] || hexBorderColors[0],
				backgroundColor: hexColors[i] || hexColors[0],
				pointBackgroundColor: hexBorderColors[i] || hexBorderColors[0],
				pointBorderColor: hexBorderColors[i] || hexBorderColors[0],
				borderWidth: this.borderWidth,
			}))
		},
	},
	mounted() {
		this.renderChart(this.chartData, this.options)
	},
}
</script>
